import { Injectable, Signal, signal } from '@angular/core'
import { UserRolesEnum } from '@isl-core/enums/user-roles.enum'
import { UserInterface } from '@isl-core/interfaces/user.interface'

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user = signal<UserInterface | null>(null)
    private _roles = signal<string[]>([])

    public get(): Signal<UserInterface | null> {
        return this._user
    }

    public get roles(): Signal<string[]> {
        return this._roles
    }

    public set(value: UserInterface | null): void {
        this._user.set(value)
    }

    public setRoles(value: string[]): void {
        const mappedRoles = value.filter((role: string) => Object.values(UserRolesEnum).includes(role as UserRolesEnum))
        this._roles.set(mappedRoles)
    }

    public hasRoles(roles: string[]): boolean {
        let result = true

        for (const role of roles) {
            result = this.roles().includes(role)
            if (!result) {
                break
            }
        }

        return result
    }

    public hasAnyRole(roles: string[]): boolean {
        let result = false

        for (const role of roles) {
            result = this.roles().includes(role)

            if (result) {
                break
            }
        }

        return result
    }
}
